import moment from "moment";
import React, { useEffect, useState } from "react";
import FunctionButton from "../../components/functionButton/FunctionButton";
import ModalFind from "../../components/modals/modalFind/ModalFind";
import ModalMove from "../../components/modals/modalMove/ModalMove";
import TransferLogModal from "../../components/modals/transferLogModal/TransferLogModal";
import ProductTable from "../../components/productTable/ProductTable";
import SaleTable from "../../components/saleTable/SaleTable";
import StatisticCounter from "../../components/statisticCounter/StatisticCounter";
import stat_orders from "../../images/icons/stat_orders.svg";
import stat_repair from "../../images/icons/stat_repair.svg";
import stat_sync from "../../images/icons/stat_sync.svg";
import { useGetPageQuery } from "../../redux/services/crmAPI";
import "./mainPage.scss";

const MainPage = () => {
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showMoveModal, setShowMoveModal] = useState(false);
    const [showTransferModal, setShowTransferModal] = useState(false);

    const { data: lastOrders } = useGetPageQuery("report/last-orders-repairs");
    const { data: orders, refetch: refetchOrders } = useGetPageQuery(
        "orders?order_status_id=1&store_id=0&sort=completed_at&from_completed_date=" +
            moment(new Date()).format("DD.MM.YYYY")
    );
    // const { data: notAcceptedProducts, refetch: refetchProduct } = useGetPageQuery("products/not-accepted");
    // const [acceptProduct, { isError: acceptProductIsError, isLoading }] = useSendFormMutation();

    // const acceptProductHandler = async () => {
    //     const formData = {
    //         product_ids: notAcceptedProducts.map((product) => product.id),
    //     };

    //     await acceptProduct({ body: formData, url: "products/accept", method: "POST" }).unwrap();
    //     await refetchProduct();

    //     if (!acceptProductIsError) {
    //         succsesDataChangeAlert();
    //     }
    // };

    useEffect(() => {
        const refetch = async () => {
            await refetchOrders();
        };
        refetch();
    }, []);

    return (
        <>
            {lastOrders && (
                <div className="content">
                    <ModalFind
                        showSearchModal={showSearchModal}
                        setShowSearchModalWindow={setShowSearchModal}
                    />
                    <ModalMove
                        showMoveModal={showMoveModal}
                        setShowMoveModal={setShowMoveModal}
                    />
                    <TransferLogModal
                        showModal={showTransferModal}
                        setShowModal={setShowTransferModal}
                    />
                    <div className="col-12">
                        <div className="functions">
                            <FunctionButton
                                name={"Переміщення"}
                                bgColor={"#c17bfe"}
                                color={"black"}
                                icon={"bi bi-arrow-down-up"}
                                handleModale={setShowTransferModal}
                            />
                            <div className="functions__list">
                                <FunctionButton
                                    name={"Знайти"}
                                    bgColor={"#ffc107"}
                                    color={"black"}
                                    icon={"bi bi-search"}
                                    handleModale={setShowSearchModal}
                                />
                                <FunctionButton
                                    name={"Перенести"}
                                    bgColor={"#1e7e34"}
                                    color={"white"}
                                    icon={"bi bi-arrow-left-right"}
                                    handleModale={setShowMoveModal}
                                />
                                <FunctionButton
                                    name={"Нове замовлення"}
                                    bgColor={"#0062cc"}
                                    color={"white"}
                                    icon={"bi bi-bag-dash"}
                                    navigateTo={"/order"}
                                />
                                <FunctionButton
                                    name={"Новий ремонт"}
                                    bgColor={"#bd2130"}
                                    color={"white"}
                                    icon={"bi bi-wrench-adjustable"}
                                    navigateTo={"/repair"}
                                />
                                <FunctionButton
                                    name={"Новий запит"}
                                    bgColor={"#117a8b"}
                                    color={"white"}
                                    icon={"bi bi-clock"}
                                    navigateTo={"/request"}
                                />
                            </div>
                        </div>
                        <div className="statistic">
                            <StatisticCounter
                                firstBg={"#85c7f5"}
                                secondBg={"#0178dd"}
                                todayCount={lastOrders.orders_last_day}
                                todayText={"Замовлень сьогодні"}
                                yesterdayCount={lastOrders.orders_prev_day}
                                yesterdayText={"Замовлень вчора"}
                                weekCount={lastOrders.orders_week}
                                weekText={"Замовлень за 7 днів"}
                                image={stat_orders}
                            />
                            <StatisticCounter
                                firstBg={"#fdbc99"}
                                secondBg={"#f76285"}
                                todayCount={lastOrders.repairs_last_day}
                                todayText={"Ремонтів сьогодні"}
                                yesterdayCount={lastOrders.repairs_prev_day}
                                yesterdayText={"Ремонтів вчора"}
                                weekCount={lastOrders.repairs_week}
                                weekText={"Ремонтів за 7 днів"}
                                image={stat_repair}
                            />
                            <StatisticCounter
                                firstBg={"#76dad0"}
                                secondBg={"#0dbd9e"}
                                todayCount={"0"}
                                todayText={"Сінхронізовано сьогодні"}
                                yesterdayCount={"0"}
                                yesterdayText={"Сінхронізовано а 7 днів"}
                                weekCount={"0"}
                                weekText={"Сінхронізовано всього"}
                                image={stat_sync}
                            />
                        </div>
                        {/* <div data-partload="main_waiting_np" data-params="" data-nospinner="1">
                            <div className="col-12">
                                <div className="alert alert-danger">
                                    <h6>У вас є замовлення, які прибули у відділення, нагадайте про це клієнтам!</h6>

                                    <div>
                                        <a
                                            href="order?id=181076"
                                            target="_blank"
                                            className="btn btn-sm text-dark badge-wait-order me-1"
                                        >
                                            Замовлення #181076 | 09.06.2023
                                        </a>
                                        <a
                                            href="order?id=181156"
                                            target="_blank"
                                            className="btn btn-sm text-dark badge-wait-order me-1"
                                        >
                                            Замовлення #181156 | 12.06.2023
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        {/* {notAcceptedProducts?.length > 0 && (
                            <div className="orders">
                                <div className="orders__counter">
                                    У вас є{" "}
                                    <Link className="orders__counter-link">
                                        {notAcceptedProducts.length} замовлення
                                    </Link>
                                    , що очікує на прийняття!
                                </div>
                                <div className="orders__items">
                                    {notAcceptedProducts.map((product) => {
                                        return <OrderItem key={product.id} product={product} />;
                                    })}
                                </div>
                                <button className="btn btn-primary mt-3" onClick={acceptProductHandler}>
                                    {isLoading ? "Опрацювання" : "Прийняти всі"}
                                </button>
                            </div>
                        )} */}
                        {orders?.data.length > 0 && (
                            <div className="card">
                                <div className="card-header">Продажі</div>
                                <div className="card-body">
                                    <div className="col-12">
                                        <SaleTable orders={orders} />
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="card">
                            <div className="card-header">Нові товари</div>
                            <div className="card-body">
                                <div className="row">
                                    <ProductTable />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default MainPage;
